import { render, staticRenderFns } from "./Product_2.vue?vue&type=template&id=1f2a3688&"
import script from "./Product_2.vue?vue&type=script&lang=js&"
export * from "./Product_2.vue?vue&type=script&lang=js&"
import style0 from "./Product_2.vue?vue&type=style&index=0&id=1f2a3688&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports